import { Button, Typography } from "@material-ui/core";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
// import { Box } from "@material-ui/core";
import Box from '@mui/material/Box';

import React from "react";

interface statusType {
  image: string;
  heading: string;
  desc: string;
  buttonText: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxRoot: {
      "@media (min-width: 1280px)": {
        height: "100vh",
        padding: "10px",
        border: "1px transparent grey",
        boxShadow: "0 24px 55px 10px rgb(13 12 12 / 30%)",
        borderRadius: "5px",
      },
      [theme.breakpoints.down("xs")]: {
        height: "100vh",
        padding: "10px",
      },
      [theme.breakpoints.between("sm", "md")]: {
        height: "100vh",
        padding: "10px",
      },
    },
    img: {
      margin: "50px 0px 60px 0px",
    },
    root: {
      padding: "5px 45px",
      borderRadius: "19px",
      backgroundColor: "#DA222C",
      color: "#fff",
      margin: "25px",
    },
  })
);

export default function Status(props: statusType) {
  const { image, heading, desc, buttonText } = props;
  const classes = useStyles();
  const onClickButton = () => {
    window.location.href = "/dashboard";
  };
  return (
    <Box className="appPendigContainer" component="div" textAlign="center">
      <Box component="div">
        <img src={image} className={classes.img} alt="pending status" />
      </Box>
      <Box component="div">
        <Typography variant="h6">{heading}</Typography>
      </Box>
      <Box component="div" mt={5}>
        <Typography>{desc}</Typography>
      </Box>
      <Box textAlign="center" mt={10}>
        <Button
          variant="contained"
          color="secondary"
          className="redButton"
          onClick={() => onClickButton()}
        >
          {buttonText}
        </Button>
      </Box>
    </Box>
  );
}
